export const JSON_DATE_REGEXP = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/;

export function parseJSONDates (key, value) {
  if ( typeof value === 'string' ) {

    if ( JSON_DATE_REGEXP.test(value) ) {
      return new Date(value);
    }
  }
  return value;
}

const jsonJsFn = `
  (function (n, d) {
    if (n in window) {
      window[n](d);
    } else {
      window[n] = d;
    }
  })
`.replace(/(\s+|;)/g, '').replace('ninw', 'n in w');


export function json2js (json, callbackName) {
  if (typeof json !== 'string') {
    json = JSON.stringify(json);
  }
  return jsonJsFn + `('__jsonjs__${callbackName}',${json})`;
}

export function jsJsonPromise (callbackName, timeout=30000) {
  let fullCallbackName = `__jsonjs__${callbackName}`;
  return new Promise((resolve, reject) => {
    if (fullCallbackName in window) {
      resolve(window[fullCallbackName])
    } else {
      let callbackTimeout = setTimeout(()=>{
        reject(new Error(`jsJson promise ${callbackName} timed out after ${timeout}ms`));
      }, timeout);
      window[fullCallbackName] = (data) => {
        clearTimeout(callbackTimeout);
        resolve(data);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/json.js